"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputProviderController = exports.KHPadAxis = exports.KHPadInput = void 0;
const KHEventHandler_1 = require("../KHEventHandler");
const KHInputAxis_1 = require("./Axis/KHInputAxis");
const KHInputKey_1 = require("./Key/KHInputKey");
const KHInputProvider_1 = require("./KHInputProvider");
var KHPadInput;
(function (KHPadInput) {
    KHPadInput[KHPadInput["Left"] = 0] = "Left";
    KHPadInput[KHPadInput["Right"] = 1] = "Right";
    KHPadInput[KHPadInput["Up"] = 2] = "Up";
    KHPadInput[KHPadInput["Down"] = 3] = "Down";
    KHPadInput[KHPadInput["A"] = 4] = "A";
    KHPadInput[KHPadInput["B"] = 5] = "B";
    KHPadInput[KHPadInput["X"] = 6] = "X";
    KHPadInput[KHPadInput["Y"] = 7] = "Y";
    KHPadInput[KHPadInput["Select"] = 8] = "Select";
    KHPadInput[KHPadInput["Start"] = 9] = "Start";
    KHPadInput[KHPadInput["L1"] = 10] = "L1";
    KHPadInput[KHPadInput["R1"] = 11] = "R1";
})(KHPadInput = exports.KHPadInput || (exports.KHPadInput = {}));
var KHPadAxis;
(function (KHPadAxis) {
    KHPadAxis[KHPadAxis["LeftStickX"] = 0] = "LeftStickX";
    KHPadAxis[KHPadAxis["LeftStickY"] = 1] = "LeftStickY";
    KHPadAxis[KHPadAxis["RightStickX"] = 2] = "RightStickX";
    KHPadAxis[KHPadAxis["RightStickY"] = 3] = "RightStickY";
})(KHPadAxis = exports.KHPadAxis || (exports.KHPadAxis = {}));
class KHInputProviderController extends KHInputProvider_1.KHInputProvider {
    constructor(scene, gamePadNumber) {
        super();
        this.scene = scene;
        this.gamePadNumber = gamePadNumber;
        this.emitter = new KHEventHandler_1.KHEventHandler([
            KHInputProviderController.EVENT_CONTROLLER_DISCONNECTED,
            KHInputProviderController.EVENT_CONTROLLER_CONNECTED
        ]);
        this.buttons = new Map();
        this.buttons.set(KHPadInput.A, new KHInputKey_1.KHInputKey());
        this.buttons.set(KHPadInput.B, new KHInputKey_1.KHInputKey());
        this.buttons.set(KHPadInput.X, new KHInputKey_1.KHInputKey());
        this.buttons.set(KHPadInput.Y, new KHInputKey_1.KHInputKey());
        this.buttons.set(KHPadInput.Left, new KHInputKey_1.KHInputKey());
        this.buttons.set(KHPadInput.Right, new KHInputKey_1.KHInputKey());
        this.buttons.set(KHPadInput.Up, new KHInputKey_1.KHInputKey());
        this.buttons.set(KHPadInput.Down, new KHInputKey_1.KHInputKey());
        this.buttons.set(KHPadInput.Start, new KHInputKey_1.KHInputKey());
        this.buttons.set(KHPadInput.Select, new KHInputKey_1.KHInputKey());
        this.buttons.set(KHPadInput.L1, new KHInputKey_1.KHInputKey());
        this.buttons.set(KHPadInput.R1, new KHInputKey_1.KHInputKey());
        this.axis = new Map();
        this.axis.set(KHPadAxis.LeftStickX, new KHInputAxis_1.KHInputAxis());
        this.axis.set(KHPadAxis.LeftStickY, new KHInputAxis_1.KHInputAxis());
        this.axis.set(KHPadAxis.RightStickX, new KHInputAxis_1.KHInputAxis());
        this.axis.set(KHPadAxis.RightStickY, new KHInputAxis_1.KHInputAxis());
        this.connected = false;
    }
    tryVibrate(duration, weak, strong) {
        let gamepad = this.getGamepad();
        if (!gamepad) {
            return;
        }
        let haptics = gamepad.vibration;
        if (haptics) {
            // playEffect is more flexible, so attempt to use that first
            if (haptics.playEffect) {
                haptics.playEffect('dual-rumble', {
                    startDelay: 0,
                    duration: duration,
                    weakMagnitude: weak,
                    strongMagnitude: strong,
                });
            }
            else if (haptics.pulse) {
                let strength = Math.max(weak, strong);
                haptics.pulse(strength, duration);
            }
        }
    }
    updateConnect(gamepad) {
        if (this.connected) {
            return;
        }
        this.connected = true;
        this.emitter.emitEvent(KHInputProviderController.EVENT_CONTROLLER_CONNECTED, { gamepad: gamepad });
    }
    updateDisconnect() {
        if (!this.connected) {
            return;
        }
        this.connected = false;
        this.buttons.forEach((value, key) => {
            value.update(false);
        });
        this.emitter.emitEvent(KHInputProviderController.EVENT_CONTROLLER_DISCONNECTED, {});
    }
    getGamepad() {
        if (!this.scene.input.gamepad || this.gamePadNumber >= this.scene.input.gamepad.gamepads.length) {
            this.updateDisconnect();
            return null;
        }
        let gamePad = this.scene.input.gamepad.gamepads[this.gamePadNumber];
        if (!gamePad) {
            this.updateDisconnect();
            return null;
        }
        this.updateConnect(gamePad);
        return gamePad;
    }
    update(now, delta) {
        let gamePad = this.getGamepad();
        if (!gamePad)
            return;
        this._updateInput(KHPadInput.A, gamePad.A);
        this._updateInput(KHPadInput.B, gamePad.B);
        this._updateInput(KHPadInput.X, gamePad.X);
        this._updateInput(KHPadInput.Y, gamePad.Y);
        this._updateInput(KHPadInput.Left, gamePad.left);
        this._updateInput(KHPadInput.Right, gamePad.right);
        this._updateInput(KHPadInput.Up, gamePad.up);
        this._updateInput(KHPadInput.Down, gamePad.down);
        this._updateInput(KHPadInput.Start, gamePad.getButtonValue(9) == 1);
        this._updateInput(KHPadInput.Select, gamePad.getButtonValue(8) == 1);
        this._updateInput(KHPadInput.L1, gamePad.L1 > 0.9);
        this._updateInput(KHPadInput.R1, gamePad.R1 > 0.9);
        this._updateAxis(KHPadAxis.LeftStickX, gamePad.leftStick.x);
        this._updateAxis(KHPadAxis.LeftStickY, gamePad.leftStick.y);
        this._updateAxis(KHPadAxis.RightStickX, gamePad.rightStick.x);
        this._updateAxis(KHPadAxis.RightStickY, gamePad.rightStick.y);
    }
    _updateInput(input, value) {
        this.buttons.get(input).update(value);
        if (value) {
            KHInputProvider_1.KHInputProvider.lastInputSource = this;
        }
    }
    _updateAxis(axis, value) {
        if (this.axis.get(axis).update(value)) {
            KHInputProvider_1.KHInputProvider.lastInputSource = this;
        }
    }
    getInput(input) {
        return this.buttons.get(input);
    }
    getAxis(axis) {
        return this.axis.get(axis);
    }
    isDown(input) {
        return this.buttons.get(input).isDown();
    }
    isJustDown(input) {
        return this.buttons.get(input).isJustDown();
    }
    type() {
        return KHInputProviderController.INPUT_TYPE;
    }
    getId() {
        const gamepad = this.getGamepad();
        if (gamepad) {
            return gamepad.id;
        }
        else {
            return "Detached Controller";
        }
    }
}
exports.KHInputProviderController = KHInputProviderController;
KHInputProviderController.INPUT_TYPE = "controller";
KHInputProviderController.EVENT_CONTROLLER_CONNECTED = "cc";
KHInputProviderController.EVENT_CONTROLLER_DISCONNECTED = "cd";
